module.exports = __webpack_public_path__ + "img/nothing.013ba413.png";